import { EnumOptionsList } from "@/types/common";
import { BoxStatus, PackOrderStatus } from "@/types/packing";
import { useTranslation } from "react-i18next";

const usePackEnums = (addVn = false) => {
  const { t } = useTranslation();

  const PackStatusEnums: EnumOptionsList<PackOrderStatus>[] = [
    {
      key: PackOrderStatus.DRAFT,
      value: PackOrderStatus.DRAFT,
      color: "cyan",
      label: addVn ? `${t('warehouse.draft', { lng: "zh" })}/${t('warehouse.draft', { lng: "vn" })}` : t('warehouse.draft')
    },
    {
      key: PackOrderStatus.CONFIRMED,
      value: PackOrderStatus.CONFIRMED,
      color: "geekblue",
      label: addVn ? `${t('warehouse.confirmed', { lng: "zh" })}/${t('warehouse.confirmed', { lng: "vn" })}` : t('warehouse.confirmed')
    },
    {
      key: PackOrderStatus.SHUTED,
      value: PackOrderStatus.SHUTED,
      color: "green",
      label: addVn ? `${t('warehouse.shuted', { lng: "zh" })}/${t('warehouse.shuted', { lng: "vn" })}` : t('warehouse.shuted')
    },
    {
      key: PackOrderStatus.WASTED,
      value: PackOrderStatus.WASTED,
      color: "red",
      label: addVn ? `${t('warehouse.wasted', { lng: "zh" })}/${t('warehouse.wasted', { lng: "vn" })}` : t('warehouse.wasted')
    },
  ];

  const getPackStatus = (value: PackOrderStatus | null) => {
    if (value === null) return
    return PackStatusEnums.find(i => i.value === value)
  };
  const BoxStatusEnums: EnumOptionsList<BoxStatus>[] = [
    {
      key: BoxStatus.DRAFT,
      value: BoxStatus.DRAFT,
      color: "cyan",
      label: addVn ? `${t('warehouse.draft', { lng: "zh" })}/${t('warehouse.draft', { lng: "vn" })}` : t('warehouse.draft')
    },
    {
      key: BoxStatus.SHUTED,
      value: BoxStatus.SHUTED,
      color: "green",
      label: addVn ? `${t('warehouse.shuted', { lng: "zh" })}/${t('warehouse.shuted', { lng: "vn" })}` : t('warehouse.shuted')
    },
  ];

  const getBoxStatus = (value: BoxStatus | null) => {
    if (value === null) return
    return BoxStatusEnums.find(i => i.value === value)
  };



  return {
    PackStatusEnums,
    getPackStatus,
    BoxStatusEnums,
    getBoxStatus
  }
};

export default usePackEnums;